module.exports = __webpack_public_path__ + "img/utilities.229ec747.svg";